/**
 * Prices and Lemon Squeezy links (payments groundwork, 2026-10-12). All null until Jens sets
 * prices and the Lemon Squeezy store exists; the Subscription page then shows "coming soon".
 * Prices are display text only (Lemon Squeezy shows the real price, in the buyer's currency, at
 * checkout), e.g. '€4.99'.
 */
export const BILLING_CONFIG: {
  prices: { monthly: string | null; yearly: string | null };
  /** Hosted checkout links per plan; the family id is added so the webhook knows who paid. */
  checkoutUrls: { monthly: string | null; yearly: string | null };
} = {
  prices: { monthly: null, yearly: null },
  checkoutUrls: { monthly: null, yearly: null },
};
